// Aura produces better prosody per clause than per token; batch streamed
// deltas into sentence-ish fragments before sending them as Speak messages.
export const SPEAK_BATCH_MAX_CHARS = 120;
const SENTENCE_END_REGEX = /[.?!]["')\]]?(\s|$)/;

// Splits the accumulated text buffer into { sendable, remainder }: complete
// sentences (or over-long fragments) go out now, the tail waits for more text.
export const takeSpeakableFragments = (bufferText) => {
  let buffer = bufferText;
  let sendable = "";
  let match = buffer.match(SENTENCE_END_REGEX);

  while (match || buffer.length >= SPEAK_BATCH_MAX_CHARS) {
    const cutAt = match ? match.index + match[0].length : SPEAK_BATCH_MAX_CHARS;
    sendable += buffer.slice(0, cutAt);
    buffer = buffer.slice(cutAt);
    match = buffer.match(SENTENCE_END_REGEX);
  }

  return { sendable, remainder: buffer };
};
